
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.996 10.087C24.996 4.134 20.057.019 14.645.02H9.988C4.51.019.004 4.135.004 10.087c0 5.445 4.508 9.918 9.984 9.892h4.657c5.412.026 10.351-4.449 10.351-9.892z","fill":"#0079BE"}}),_c('path',{attrs:{"d":"M10.018.864C5.014.866.958 4.954.957 10.001c.001 5.045 4.056 9.133 9.06 9.135 5.006-.001 9.062-4.09 9.063-9.135-.001-5.047-4.057-9.135-9.062-9.137z","fill":"#fff"}}),_c('path',{attrs:{"d":"M4.29 9.976a5.799 5.799 0 013.686-5.404v10.807a5.796 5.796 0 01-3.687-5.403zm7.797 5.406V4.572a5.796 5.796 0 013.689 5.405 5.798 5.798 0 01-3.69 5.405z","fill":"#0079BE"}})])
          )
        }
      }
    